import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { AppSharedModule } from 'src/app/core/app-shared.module';
import { InputModule } from 'src/app/components/input/input.module';
import { LoginRoutingModule } from './login-routing.module';

@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,
    AppSharedModule,
    InputModule
  ]
})
export class LoginModule { }
